import React, { useRef } from 'react';
import DOMPurify from 'dompurify';
import ShowMoreText from 'react-show-more-text';

export const ExpandableText = ({ htmlContent, classNameText, executeOnClick }) => {
  const textRef = useRef(null);
  const sanitizedHTML = htmlContent && DOMPurify.sanitize(htmlContent);


  return (
    <div className='expandable-text-wrapper'>
      <ShowMoreText
        more='Show more'
        less='Show less'
        className={`content-css ${classNameText ? classNameText : ''}`}
        anchorClass='show-more-less-clickable'
        onClick={(isExpanded) => {
          if (executeOnClick) {
            executeOnClick(isExpanded);
          }
        }}
        expanded={false}
        truncatedEndingComponent={'...'}
      >
        <p
          ref={textRef}
          className='expandable-main-text'
          dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
        />
      </ShowMoreText>
    </div>
  );
};

